export interface Point {
  x: number;
  y: number;
}

// 화면 클릭 → 이미지 원본 픽셀 좌표 (objectFit: contain 기준)
export function toNaturalCoords(e: React.MouseEvent, img: HTMLImageElement | null): Point | null {
  if (!img) return null;

  const rect = img.getBoundingClientRect();

  // contain: 가로/세로 중 더 작은 배율로 맞춰지고 나머지는 여백(letterbox)
  const scale = Math.min(rect.width / img.naturalWidth, rect.height / img.naturalHeight);

  const dispW = img.naturalWidth * scale;
  const dispH = img.naturalHeight * scale;
  const offX = (rect.width - dispW) / 2; // 좌우 여백
  const offY = (rect.height - dispH) / 2; // 상하 여백

  const x = (e.clientX - rect.left - offX) / scale;
  const y = (e.clientY - rect.top - offY) / scale;

  // 여백(letterbox) 클릭은 무시
  if (x < 0 || y < 0 || x > img.naturalWidth || y > img.naturalHeight) {
    return null;
  }

  return { x: Math.round(x), y: Math.round(y) };
}
